import React from 'react';
import Loadable from 'react-loadable';
import {IProps} from "./interface";
import CircularProgress from "@material-ui/core/CircularProgress";

export const path = '/survey/preview/:id';

const PageSurveyPreview: React.FC<IProps> = (props) => {
    // @ts-ignore
    let loader = {
        page: () => import(`./page`),
        i18n: () => import(`./ru.json`),
    };

    let loadabled = () => {
        document.title = "BI Clients";

        return (
            <React.Fragment>
                <CircularProgress/>
            </React.Fragment>
        );
    }

    const LoadableMap = Loadable.Map({
        loader: loader,
        loading: loadabled,
        render(loaded: any): React.ReactNode {
            const Page: any = loaded.page.default;
            return (
                <Page i18n={{...loaded.i18n}} {...props} />
            );
        }
    });

    return <LoadableMap {...props} />;
};

export default PageSurveyPreview;